export enum PortletStates {
	NoChanges,
	New,
	Changed,
	Deleted
}